import React from 'react';
import clsx from 'clsx';

import Heading from '@common/Heading';
import Row from '@common/Row';
import Video from '@common/Video';

const FlexVideo = ({ data }) => {
  const { video } = data;
  return (
    <Row className={`justify-content-center mb-4`}> 
      <div className={clsx(`col`, video.imageWidth)}>
        {(video.showTitle && video.title) && <Heading type='h2' className={`text-center mb-4`}>{video.title}</Heading>}
        <Video videoId={video.videoId} image={video.image}/>
      </div>
    </Row>
  )
}

export default FlexVideo
